import { CheckIcon } from "@heroicons/react/24/solid";

const Checkbox = ({
  checkboxName, 
  checkboxInputClass, 
  isChecked, 
  checkboxLabel, 
  checkboxLableClass,
  onChange = () => {},
  ...props
}) => {
  return (
    <>
      <div className="relative overflow-hidden flex items-center gap-3">
        <input type="checkbox" 
          name={checkboxName} 
          className={"peer absolute top-0 left-0 w-5 h-5 min-w-[20px] min-h-[20px] opacity-0 z-10 cursor-pointer " + (checkboxInputClass)} 
          checked={isChecked}
          onChange={onChange}
        />
        <div className="w-5 h-5 min-w-[20px] min-h-[20px] border border-slate-300 rounded flex items-center justify-center text-sm bg-white text-black/0 peer-checked:bg-slate-900 peer-checked:border-slate-900 peer-checked:text-white">
          <CheckIcon className="w-5 h-5"/>
        </div>
        {checkboxLabel &&
        <div className={"text-sm text-slate-500 w-full " + (checkboxLableClass)}>{checkboxLabel}</div>
        }
      </div>
    </>
  );
};

export default Checkbox;